import ResumeProfilePage from './ResumeProfilePage'

export default ResumeProfilePage
